import { Gift, Trophy, Utensils } from "lucide-react";

export function CarreraBeneficios() {
  return (
    <div className="space-y-4 text-sm">
      <div className="flex items-start gap-3 border-l-4 border-accent bg-accent/5 p-4">
        <Gift className="h-5 w-5 shrink-0 text-accent" />
        <div>
          <p className="font-semibold text-primary">Regalo por clubes</p>
          <p className="mt-1">Una paletilla por cada 10 participantes del mismo club.</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-3">
        <span className="flex items-center gap-2"><Trophy size={18} className="text-primary" />Premios</span>
        <span className="flex items-center gap-2"><Gift size={18} className="text-primary" />Gran sorteo de regalos</span>
        <span className="flex items-center gap-2"><Utensils size={18} className="text-primary" />Comida popular al finalizar</span>
      </div>
    </div>
  );
}